import React from "react";
// import { Icon } from "@iconify/react";
// import closeIcon from "@iconify-icons/mdi/close";
import "../../../styles/Auth/purchasePaymentLogs.css";

export default function PurchasePaymentLogsPopup({ isOpen, onClose, purchaseLogsData }) {
    if (!isOpen || !purchaseLogsData) return null;

    // ✅ Correct Destructuring based on your response
    const purchaseDetails = purchaseLogsData?.data?.data?.purchaseDetails;
    const logs = purchaseLogsData?.data?.logs || [];

    if (!purchaseDetails) {
        return (
            <div className="purchase-payment-popup-overlay">
                <div className="purchase-payment-popup-container">
                    <h2>Unable to load purchase details</h2>
                    <button className="btn-close" onClick={onClose}>Close</button>
                </div>
            </div>
        );
    }

    return (
        <div className="purchase-payment-popup-overlay">
            <div className="purchase-payment-popup-container">
                {/* Header */}
                <div className="purchase-payment-popup-header">
                    <h2>Purchase Payment Logs</h2>
                </div>


                <hr className="divider" />

                {/* Payment History */}
                <div className="purchase-payment-popup-section">
                    <h3>Payment History</h3>
                    {logs.length > 0 ? (
                        <div className="table-wrapper">
                            <table className="logs-table">
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Payment Mode</th>
                                        <th>Amount</th>
                                        <th>Reference No</th>
                                        <th>Remarks</th>
                                        <th>Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {logs.map((log, index) => (
                                        <tr key={log._id}>
                                            <td>{index + 1}</td>
                                            <td>{log.paymentMode}</td>
                                            <td>₹{log.paymentAmount}</td>
                                            <td>{log.referenceNo}</td>
                                            <td>{log.remarks}</td>
                                            <td>{new Date(log.createdAt).toLocaleString()}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <p className="no-logs">No payment logs found.</p>
                    )}
                </div>

                {/* Footer */}
                <div className="purchase-payment-popup-footer">
                    <button className="btn-close" onClick={onClose}>Close</button>
                </div>
            </div>
        </div>
    );
}


